import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { EconomyCard } from './economy-card.component';
import { EconomyPaths } from '../economy.paths';
import { ECONOMY_ROW_LABEL_CLASS, ECONOMY_VALUE_CLASS } from '../economy-theme';
import { ALLOCATION_METHODS } from '../mock/portfolio-economy.mock';

/** Which allocation methods exist, and where per-line overrides are configured. */
export function AllocationMethodsCard() {
  const { t } = useTranslation('economy');

  return (
    <EconomyCard title={t('settings.allocationMethods.title')}>
      <p className={ECONOMY_ROW_LABEL_CLASS}>
        {t('settings.allocationMethods.available')}{' '}
        {ALLOCATION_METHODS.map((method, index) => (
          <span key={method}>
            {index > 0 && <span> · </span>}
            <span className={classNames('font-medium', ECONOMY_VALUE_CLASS)}>{t(`allocationMethod.${method}`)}</span>
          </span>
        ))}
      </p>

      <Link to={EconomyPaths.CompanyCosts} className="mt-4 inline-block text-sm font-medium text-brand-primary hover:text-brand-primary-hover hover:underline">
        {t('settings.allocationMethods.configureLink')}
      </Link>
    </EconomyCard>
  );
}

export default AllocationMethodsCard;
